import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";
import type { components } from "@/types/api/api-types";

type StatementDraftBody = components["schemas"]["CreateStatementDto"];

/** Create a new draft statement (no eligibility check, no snapshot). */
export const useSaveStatementDraft = () =>
  useMutation({
    mutationFn: async ({ body }: { body: StatementDraftBody }) => {
      const { data, error } = await (
        fetchClient as unknown as {
          POST: (
            path: "/statements/drafts",
            init: { body: StatementDraftBody },
          ) => Promise<{ data?: unknown; error?: unknown }>;
        }
      ).POST("/statements/drafts", { body });
      if (error) throw error;
      return data;
    },
  });
